import type { Schedule, SpeakerV3, Sponsor, Vendor } from "src/types";

import speakersHeadshotPlaceholder from "@/components/editor/themes/starter-hub/blocks/speakers/speakers-headshot-placeholder.jpg";

export const DEFAULT_BUTTON_TEXT = "Register";
export const DEFAULT_HEADING_TEXT = "The Future of Everything";
export const DEFAULT_SUBHEADING_TEXT =
  "Get ready for five days of disruptive ideas and ground-breaking insights as we bring together the most revolutionary minds and reflect on what our world will look like fifty years from now.";

export const DEFAULT_GOLDEN_SPONSORS: Sponsor[] = [
  {
    id: 1,
    name: "Opentech",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/opentech-logo-placeholder.0fae06ff.jpg",
  },
  {
    id: 2,
    name: "Globex",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/globex-logo-placeholder.72483839.jpg",
  },
  {
    id: 3,
    name: "KeySpace.com",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/keyspace-logo-placeholder.67c8c3ce.jpg",
  },
];

export const DEFAULT_SILVER_SPONSORS: Sponsor[] = [
  {
    id: 1,
    name: "Course",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/course-logo-placeholder.c47e833e.jpg",
  },
  {
    id: 2,
    name: "Zikakabo",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/zikakabo-logo-placeholder.c77bc802.jpg",
  },
  {
    id: 3,
    name: "Consult",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/consult-logo-placeholder.5a5c985f.jpg",
  },
  {
    id: 4,
    name: "Course",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/course-logo-placeholder.c47e833e.jpg",
  },
];

export const DEFAULT_BRONZE_SPONSORS: Sponsor[] = [
  {
    id: 1,
    name: "Texon",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/texon-logo-placeholder.64ad78ee.jpg",
  },
  {
    id: 2,
    name: "Opers",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/opers-logo-placeholder.18b4cf58.jpg",
  },
  {
    id: 3,
    name: "Cheers",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/cheers-logo-placeholder.3eaf70a6.jpg",
  },
  {
    id: 4,
    name: "Globex",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/globex-logo-placeholder.72483839.jpg",
  },
  {
    id: 5,
    name: "Combine",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/combine-logo-placeholder.2b341140.jpg",
  },
  {
    id: 6,
    name: "Stage",
    website: "https://course.co./about",
    image_url: "/canvas/shared/images/stage-logo-placeholder.edafa52c.jpg",
  },
];

export const DEFAULT_VENDORS: Vendor[] = [
  {
    id: 1111,
    booth_size: "large",
    name: "Opensource",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder",
    image_url: "/canvas/seldon/images/booth-logo-placeholder.616cd368.jpg",
    background_image:
      "/canvas/seldon/images/booth-banner-placeholder.785ef5d8.jpg",
  },
  {
    id: 2222,
    booth_size: "large",
    name: "Opensource",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder",
    image_url: "/canvas/seldon/images/booth-logo-placeholder.616cd368.jpg",
    background_image:
      "/canvas/seldon/images/booth-banner-placeholder.785ef5d8.jpg",
  },
  {
    id: 3333,
    booth_size: "large",
    name: "Opensource",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder",
    image_url: "/canvas/seldon/images/booth-logo-placeholder.616cd368.jpg",
    background_image:
      "/canvas/seldon/images/booth-banner-placeholder.785ef5d8.jpg",
  },
  {
    id: 4444,
    booth_size: "large",
    name: "Opensource",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder",
    image_url: "/canvas/seldon/images/booth-logo-placeholder.616cd368.jpg",
    background_image:
      "/canvas/seldon/images/booth-banner-placeholder.785ef5d8.jpg",
  },
  {
    id: 5555,
    booth_size: "large",
    name: "Opensource",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder",
    image_url: "/canvas/seldon/images/booth-logo-placeholder.616cd368.jpg",
    background_image:
      "/canvas/seldon/images/booth-banner-placeholder.785ef5d8.jpg",
  },
  {
    id: 6666,
    booth_size: "large",
    name: "Opensource",
    headline:
      "Open-source software is a type of computer software in which source code is released under a license in which the copyright holder",
    image_url: "/canvas/seldon/images/booth-logo-placeholder.616cd368.jpg",
    background_image:
      "/canvas/seldon/images/booth-banner-placeholder.785ef5d8.jpg",
  },
];

export const DEFAULT_SPEAKERS: SpeakerV3[] = [
  {
    id: 1,
    first_name: "Speaker",
    last_name: "Name",
    headline: "Headline",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: speakersHeadshotPlaceholder.src,
  },
  {
    id: 2,
    first_name: "Speaker",
    last_name: "Name",
    headline: "Headline",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: speakersHeadshotPlaceholder.src,
  },
  {
    id: 3,
    first_name: "Speaker",
    last_name: "Name",
    headline: "Headline",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: speakersHeadshotPlaceholder.src,
  },
  {
    id: 4,
    first_name: "Speaker",
    last_name: "Name",
    headline: "Headline",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: speakersHeadshotPlaceholder.src,
  },
];

export const DEFAULT_SCHEDULES: Schedule[] = [
  {
    date: "February 19",
    schedules: [
      {
        id: 0,
        name: "Planning for the next pandemic",
        time_end: "2021-02-19T23:00:00.000Z",
        time_start: "2021-02-19T19:00:00.000Z",
        description:
          "Each year the Journal’s newsroom identifies what—and who—is creating the biggest seismic shifts in how we live, work and play.",
        external_id: "AALEUra7aAJe2D3nuvOjQfCOQ",
        event_part: {
          event_part_type: "stage",
          event_type_custom_text: "Stage",
        },
        speakers: [],
        tags: [],
      },
      {
        id: 1,
        name: "The impact of AI and VR",
        time_end: "2021-02-19T23:00:00.000Z",
        time_start: "2021-02-19T19:00:00.000Z",
        description:
          "It’s from this exploration that The Future of Everything Festival becomes an extraordinary intersection of industries, innovators and ideas.",
        external_id: "08a0dd8a",
        event_part: {
          event_part_type: "stage",
          event_type_custom_text: "Stage",
        },
        speakers: [],
        tags: [
          {
            external_id: null,
            name: "vr",
            priority: 1,
          },
        ],
      },
    ],
  },
];
